import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Heart } from "lucide-react";
import { toast } from "sonner";
import { useWishlist } from "../context/WishlistContext";
import { useAuth } from "../context/AuthContext";
import { StarRating } from "./StarRating";

export const ProductCard = ({ product, index = 0 }) => {
  const { isWishlisted, toggle } = useWishlist();
  const { user } = useAuth();
  const navigate = useNavigate();
  const wished = isWishlisted(product.id);
  const rating = product.rating || { average: 0, count: 0 };

  const handleWish = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user) { toast.error("Log in to save favorites"); navigate("/login"); return; }
    toggle(product.id);
    toast.success(wished ? "Removed from wishlist" : "Saved to wishlist");
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4, delay: (index % 3) * 0.08 }}
      data-testid={`product-card-${product.id}`}
    >
      <Link to={`/product/${product.id}`} className="group block border border-zinc-800 bg-zinc-900 hover:border-white transition-colors duration-200 hover:-translate-y-1 will-change-transform" style={{ transitionProperty: "border-color, transform" }}>
        <div className="relative aspect-square overflow-hidden bg-zinc-950">
          <img src={product.images?.[0]} alt={product.name}
            className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-300" />
          {product.featured && (
            <span className="absolute top-3 left-3 bg-[#FF3B30] text-white text-[10px] font-bold uppercase tracking-widest px-2 py-1">Hot</span>
          )}
          <button
            onClick={handleWish}
            data-testid={`wishlist-toggle-${product.id}`}
            aria-label="Toggle wishlist"
            className="absolute top-2 right-2 p-2 bg-black/60 hover:bg-black/80 transition-colors"
          >
            <Heart size={16} className={wished ? "fill-[#FF3B30] text-[#FF3B30]" : "text-white"} />
          </button>
        </div>
        <div className="p-4">
          <div className="flex items-center justify-between gap-2">
            <h3 className="font-bold text-sm uppercase tracking-tight leading-tight">{product.name}</h3>
            <span className="font-display text-xl text-[#FF3B30] whitespace-nowrap">${product.price.toFixed(2)}</span>
          </div>
          {rating.count > 0 && (
            <div className="flex items-center gap-2 mt-2" data-testid={`card-rating-${product.id}`}>
              <StarRating value={rating.average} size={12} />
              <span className="text-[11px] text-zinc-500">{rating.average} ({rating.count})</span>
            </div>
          )}
        </div>
      </Link>
    </motion.div>
  );
};
